var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isHidden,
          expression: "!isHidden"
        }
      ],
      staticClass: "selection",
      class: [
        _vm.tab,
        "state-" + _vm.currentBetSlipState,
        _vm.isInterRelated ? "interRelated-" + _vm.isInterRelated : "",
        {
          FastBet: _vm.isFastBet,
          isLive: _vm.isLive,
          priceUp: _vm.priceUp,
          priceDown: _vm.priceDown,
          hcpUp: _vm.hcpUp,
          hcpDown: _vm.hcpDown,
          isClosed: _vm.isClosed,
          isSuspended: _vm.isSuspended,
          edit: _vm.currentBetSlipState == 0,
          review: _vm.currentBetSlipState == 1,
          inPlacement: _vm.currentBetSlipState > 1,
          notStaked: !_vm.stake,
          oddsBust: _vm.pricetype === "XP",
          interRelated: _vm.isInterRelated,
          optedOut: !_vm.optedIn[_vm.id],
          isForSinglesOnly: _vm.isForSinglesOnly,
          isForBB: _vm.isForBB
        }
      ]
    },
    [
      [
        _vm.brandTemplate === "generic_2"
          ? _c("div", { staticClass: "selection-remove" }, [
              _vm.currentBetSlipState < 1
                ? _c(
                    "button",
                    {
                      staticClass: "btnX",
                      on: {
                        click: function($event) {
                          return _vm.removeSelection(_vm.selection)
                        }
                      }
                    },
                    [_c("icon", { attrs: { name: "icon-trash-white" } })],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "selection-core" }, [
          !_vm.isFastBet || _vm.betslipLayout2
            ? _c("div", { staticClass: "event-name" }, [
                !_vm.betslipLayout2
                  ? _c(
                      "div",
                      { staticClass: "bs_left" },
                      [
                        _c("icon", {
                          attrs: {
                            colorName: "white",
                            name:
                              "icon-" +
                              (_vm.selection.idfosporttype &&
                                _vm.selection.idfosporttype.split(" ").join(""))
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "eventname" }, [
                          _c("span", { attrs: { id: "name" } }, [
                            _vm._v(_vm._s(_vm.selectionName))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "currenthandicap",
                              class: [
                                { hcpUp: _vm.hcpUp },
                                { hcpDown: _vm.hcpDown }
                              ]
                            },
                            [_vm._v(_vm._s(_vm.handicap) + " ")]
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.betslipLayout2
                  ? _c("div", { staticClass: "bs_left betslipLayout2" }, [
                      _c("div", { staticClass: "event_and_market_name" }, [
                        _c("div", { staticClass: "eventname" }, [
                          _c("span", { attrs: { id: "name" } }, [
                            _vm._v(_vm._s(_vm.selectionName))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "currenthandicap",
                              class: [
                                { hcpUp: _vm.hcpUp },
                                { hcpDown: _vm.hcpDown }
                              ]
                            },
                            [_vm._v(_vm._s(_vm.handicap) + " ")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "market-name" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.market.name) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.showExternalDescriptionForFlashBettingMarkets &&
                        _vm.market &&
                        _vm.market.externaldescription &&
                        _vm.market.externaldescription !== _vm.market.name
                          ? _c(
                              "div",
                              { staticClass: "market-external-description" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.market.externaldescription) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "selection-price odds",
                          class: "pricetype-" + _vm.pricetype
                        },
                        [
                          !_vm.isClosed && !_vm.isSuspended
                            ? [
                                _c("div", { staticClass: "price" }, [
                                  _vm.isOddsBoost
                                    ? _c(
                                        "i",
                                        {
                                          staticClass: "icon material-icons",
                                          attrs: { "aria-hidden": "true" }
                                        },
                                        [_vm._v("arrow_upward")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "price",
                                      class: [
                                        { priceUp: _vm.priceUp },
                                        { priceDown: _vm.priceDown }
                                      ]
                                    },
                                    [_vm._v(_vm._s(_vm.price))]
                                  )
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isClosed || _vm.isSuspended
                            ? _c("span", { staticClass: "price" }, [
                                _vm.isClosed
                                  ? _c("span", { staticClass: "price_title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("BetSlip.selection.isClosed")
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isSuspended
                                  ? _c("span", { staticClass: "price_title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "BetSlip.selection.isSuspended"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "bs_right" }, [
                  !_vm.betslipLayout2
                    ? _c("div", { staticClass: "market-name" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.market.name) +
                            "\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brandTemplate !== "generic_2" &&
                  _vm.currentBetSlipState < 1
                    ? _c(
                        "button",
                        {
                          staticClass: "btnX",
                          on: {
                            click: function($event) {
                              return _vm.removeSelection(_vm.selection)
                            }
                          }
                        },
                        [_c("icon", { attrs: { name: "icon-trash-white" } })],
                        1
                      )
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "selection-data columns" }, [
            _vm.isLive || _vm.showCheckbox
              ? _c(
                  "div",
                  { staticClass: "column-left" },
                  [
                    _vm.showCheckbox === true
                      ? _c("v-checkbox", {
                          attrs: {
                            type: "checkbox",
                            id: _vm.id.toString(),
                            value: _vm.optedIn[_vm.id],
                            disabled: _vm.disableOptedIn
                          },
                          on: {
                            change: function($event) {
                              return _vm.updateOptedIn()
                            }
                          },
                          model: {
                            value: _vm.optedIn[_vm.id],
                            callback: function($$v) {
                              _vm.$set(_vm.optedIn, _vm.id, $$v)
                            },
                            expression: "optedIn[id]"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isLive && !_vm.betslipLayout2
                      ? _c("span", { staticClass: "isLive" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("BetSlip.selection.isLive")))
                          ])
                        ])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "column-right" }, [
              _c(
                "div",
                { staticClass: "selectionName" },
                [
                  _vm.betslipLayout2 && _vm.brandTemplate !== "generic_2"
                    ? _c("icon", {
                        attrs: {
                          colorName: "white",
                          name:
                            "icon-" +
                            (_vm.selection.idfosporttype &&
                              _vm.selection.idfosporttype.split(" ").join(""))
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "event-name-line-1" }, [
                    _vm._v(_vm._s(_vm.wbr(_vm.eventName, 0)))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "event-name-line-2" }, [
                    _vm._v(_vm._s(_vm.wbr(_vm.eventName, 1)))
                  ]),
                  _vm._v(" "),
                  _vm.isLive && _vm.betslipLayout2
                    ? _c("span", { staticClass: "isLive" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("BetSlip.selection.isLive")))
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.statusToConfirm
                    ? _c("span", { staticClass: "statusToConfirm" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "BetSlip.placement.bet." + _vm.statusToConfirm
                            )
                          )
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.isForBB
                ? _c(
                    "span",
                    { staticClass: "isForBB" },
                    [_c("icon", { attrs: { name: "icon-available-for-bb" } })],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.showEventTsStart
            ? _c(
                "div",
                { staticClass: "selection-data selectionName columns" },
                [
                  _c(
                    "div",
                    { staticClass: "column-right" },
                    [
                      _c("ts-start", {
                        attrs: {
                          tsstart:
                            _vm.market.tsstartWithOffset || _vm.market.tsstart
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "additional-data" },
            [
              _c(
                "div",
                { staticClass: "stake_price" },
                [
                  _c(
                    "div",
                    { staticClass: "special-offers-eligible" },
                    [
                      _c("special-offers", {
                        attrs: {
                          mode: "eligible",
                          id: _vm.id,
                          isSGP: false,
                          allowedBetTypesAndReturns:
                            _vm.allowedBetTypesAndReturn,
                          perType: "PerSelection"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.betslipLayout2
                    ? _c(
                        "div",
                        {
                          staticClass: "selection-price odds",
                          class: "pricetype-" + _vm.pricetype
                        },
                        [
                          !_vm.isClosed && !_vm.isSuspended
                            ? [
                                _c("span", { staticClass: "price_title" }, [
                                  _vm._v(_vm._s(_vm.$t("BetSlip.oddsprice")))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "price" }, [
                                  _vm.isOddsBoost
                                    ? _c(
                                        "i",
                                        {
                                          staticClass: "icon material-icons",
                                          attrs: { "aria-hidden": "true" }
                                        },
                                        [_vm._v("arrow_upward")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "price",
                                      class: [
                                        { priceUp: _vm.priceUp },
                                        { priceDown: _vm.priceDown }
                                      ]
                                    },
                                    [_vm._v(_vm._s(_vm.price))]
                                  )
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isClosed || _vm.isSuspended
                            ? _c("span", { staticClass: "price" }, [
                                _vm.isClosed
                                  ? _c("span", { staticClass: "price_title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("BetSlip.selection.isClosed")
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isSuspended
                                  ? _c("span", { staticClass: "price_title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "BetSlip.selection.isSuspended"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canBePlacedAsSingle
                    ? _c("stake-and-return", {
                        attrs: {
                          id: _vm.selection.idfoselection,
                          perType: "PerSelection",
                          tab: _vm.tab,
                          currentBetSlipState: _vm.currentBetSlipState,
                          allowedBetTypesAndReturns:
                            _vm.allowedBetTypesAndReturn,
                          isFastBet: _vm.isFastBet,
                          derivativeId: _vm.derivativeId,
                          statusToConfirm: _vm.statusToConfirm
                        },
                        on: { hideBetType: _vm.hideBetType }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.selection &&
              _vm.selection.isPitcherSource &&
              _vm.tab == "REGULAR"
                ? _c("listed-pitchers", {
                    attrs: {
                      tab: _vm.tab,
                      id: _vm.selection.idfoselection,
                      marketName: _vm.marketName,
                      currentBetSlipState: _vm.currentBetSlipState,
                      isFastBet: _vm.isFastBet
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.selection &&
              _vm.selection.isBuyPointsSource &&
              _vm.tab == "REGULAR" &&
              _vm.currentBetSlipState <= 1
                ? _c("buy-points-option", {
                    attrs: {
                      tab: _vm.tab,
                      id: _vm.selection.idfoselection,
                      selection: _vm.selection,
                      currentBetSlipState: _vm.currentBetSlipState,
                      isFastBet: _vm.isFastBet
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dddff94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dddff94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/selections/selectionRegular.vue
// module id = null
// module chunks = 